import { Button, Form as AntdForm, FormProps } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { breakpoints } from 'theme/variables';
import { isFormValid } from 'common/helpers/formHelpers';

import { ResetButton } from '..';
import { FormHeader } from '../styled';

const FormWrapper = styled.div`
    && {
        width: 100%;
        padding: 1rem;

        ${breakpoints.small} {
            padding: 1.25rem 1.5rem;
        }

        ${breakpoints.medium} {
            padding: 1.5rem 2rem;
        }
    }
`;

const SubmitButton = styled(Button)`
    &&& {
        width: 100%;
        height: 46px;
        border-radius: 8px;
        font-size: 0.92rem;
        font-weight: 600;
        font-family: 'Inter', sans-serif;
        margin-top: 8px;
    }
`;

type Props = FormProps & {
    header?: string;
    showResetButton?: boolean;
    submitButtonText?: string;
    hideSubmitButton?: boolean;
};

export const Form = (props: Props) => {
    const [isValid, setIsValid] = useState(false);

    const { showResetButton, submitButtonText, hideSubmitButton, header, children, ...formProps } =
        props;

    useEffect(() => {
        checkIsFormValid();
    }, []);

    const checkIsFormValid = () => {
        setIsValid(isFormValid(formProps.form));
    };

    return (
        <FormWrapper>
            {header && <FormHeader>{header}</FormHeader>}
            {showResetButton && <ResetButton onReset={() => formProps.form?.resetFields()} />}
            <AntdForm {...formProps} layout="vertical" onFieldsChange={checkIsFormValid}>
                {children}
                {!hideSubmitButton && (
                    <SubmitButton disabled={!isValid} type="primary" htmlType="submit">
                        {submitButtonText || 'Save'}
                    </SubmitButton>
                )}
            </AntdForm>
        </FormWrapper>
    );
};
